module.exports = {
  title: 'Paper Folding Animation with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-07-30',
  slug: 'paper-folding',
  tags: ['skia'],
};
